import React from 'react';

import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import JoinInfoPage from './JoinInfoPage';

type Props = {
  onDone: (group: Group) => void;
  onRequestHide: () => void;
  groupCode: string;
};

class JoinInfoModal extends React.Component<Props> {
  onDone = (group: Group) => {
    const { onDone, onRequestHide } = this.props;

    onRequestHide();
    onDone(group);
  };

  render() {
    const { groupCode, onRequestHide } = this.props;

    return (
      <Dialog onRequestHide={onRequestHide} size="small">
        <JoinInfoPage groupCode={groupCode} onDone={this.onDone} />
      </Dialog>
    );
  }
}

export default JoinInfoModal;
